import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
//@ts-ignore
import styles from './investors.module.css'

interface IInvestor {
    image: {
        file: {
            url: string;
        }
    }
    name: string;
    homepageUrl: string;
    description: string;
}
const useInvestorQuery = (): {investors: Array<IInvestor>; investorText: string} => {
    const data = useStaticQuery(graphql`
    query Investors {
        allContentfulLogo(filter: {name: {in: ["xrclabslogo", "seedlablogo", "antlerlogo", "loyal-vc"]}}){
            nodes {
                image {
                    file {
                        url
                    }
                }
                name
                homepageUrl
                description
          
            }
        }
        contentfulTargetedText(name: {eq: "vc intro"}){
            content {
                childrenMarkdownRemark{
                    html
                }
            }
        }
    }
    `)
    console.log({data})
    return {
        investors: data?.allContentfulLogo?.nodes, 
        investorText: data?.contentfulTargetedText?.content?.childrenMarkdownRemark?.[0]?.html 
    };
}

const InvestorCard: React.FunctionComponent<{data: IInvestor}> = ({data}) => {
    return (
        <div className={styles.invCard}>
            <a href={data?.homepageUrl}>
            <img className={styles.logoImg} src={data?.image?.file?.url}></img>
            </a>
            {/* <span>{data?.description}</span> */}
        </div>
    )
}
export const Investors: React.FunctionComponent = () => {
    const {investors, investorText} = useInvestorQuery();
    // console.log({investorText})
    return (
        <div className={styles.investorContainer}>
            <div className={styles.sectionHeaderText} dangerouslySetInnerHTML={{__html: investorText}} ></div>
            {/* <p className={styles.sectionHeaderText}>We are backed by the following VCs</p> */}
            <div className={styles.invCardContainer}>
                {
                    investors?.map((inv, _) => <InvestorCard data={inv}/>)
                }
            </div>
        </div>
    )
}